import { z } from 'zod'

export const paymentPlanSchema = z.object({
  total_amount: z.coerce.number().min(0.01),
  installment_amount: z.coerce.number().min(0.01),
  frequency: z.enum(['weekly', 'biweekly', 'monthly', 'harvest', 'custom']),
  start_date: z.string().min(1),
  end_date: z.string().optional(),
  notes: z.string().optional(),
})

export type PaymentPlanFormData = z.infer<typeof paymentPlanSchema>
